import styles from "./EmailConfirmModal.module.scss";
import email from "../../../assets/icons/email.svg";
import Button from "../../button/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../../../utils/analytics";
import { EVENT_NAMES } from "../../../types/event-names";
import { useEffect, useState } from "react";

interface EmailConfirmModalProps {
  setIsModalConfirmVisible: (arg: boolean) => void;
}

const EmailConfirmModal: React.FC<EmailConfirmModalProps> = ({ setIsModalConfirmVisible }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [resendCoolDown, setResendCoolDown] = useState<number>(0);

  const onClickResendEmailHandler = async () => {
    if (resendCoolDown > 0) return; // Prevent multiple clicks

    try {
      setResendCoolDown(30);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (resendCoolDown === 0) return;

    const interval = setInterval(() => {
      setResendCoolDown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [resendCoolDown]);

  return (
    <div className={styles.root} onClick={() => navigate("/email-change")}>
      <img src={email} alt="email" className={styles.root_img} />
      <p className={styles.root_title}>{t("Email Update Confirmation Sent")}</p>
      <p className={styles.root_message}>{t("Check Your New Email for the Confirmation Link")}</p>
      <p className={styles.root_subtitle}>
        {t(
          "Please check your inbox for an email containing a confirmation link to update your email address. If you don't see the email, check your spam/junk folder."
        )}
      </p>
      <p
        className={`${styles.root_reSend} ${resendCoolDown > 0 ? styles.root_reSend_disabled : ""}`}
        onClick={onClickResendEmailHandler}
      >
        {resendCoolDown > 0 ? `${t("Re-send Email")}: ${resendCoolDown}` : t("Re-send Email")}
      </p>
      <div className={styles.root_footer}>
        <p>{t("Still need help?")}</p>
        <a
          onClick={() => {
            trackEvent(EVENT_NAMES.CONTACT_SUPPORT, {
              source: "email_confirm",
            });
          }}
          href="https://www.fortect.com/support/"
          target="_blank"
          rel="noreferrer"
          className={styles.root_footer_link}
        >
          {" "}
          {t("Contact support")}
        </a>
      </div>
      <Button onClick={() => setIsModalConfirmVisible(false)} text={t("Close")} classNames={styles.root_button} />
    </div>
  );
};

export default EmailConfirmModal;
